/**
 * O nome do checkout contra o plano dele (Vitor, 29/10/2026). O nome e texto livre, so o que o comprador le; o plano e
 * o que ele recebe. Em 28/09 nasceu um "Fast EXPERT" ligado ao Exame Expert e, por um mes, quem comprou o Fast recebeu o
 * Exame (e a Guru somou os dois). O painel avisa quando alguma palavra do nome do plano falta no nome do checkout e so
 * cria (ou salva) com a confirmacao de quem esta mexendo: nome de campanha continua valendo.
 */

/** Palavras sem acento, minusculas, sem simbolo: "MTC GLOBAL $100K" e "MTC Global 100K" dao as mesmas. */
const palavras = (t: string) =>
  t.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase().split(/[^\p{L}\p{N}]+/u).filter((p) => p.length >= 2);

const semSimbolo = (p: string) => p.replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}]+$/gu, "");

/** As palavras do nome do plano que nao aparecem no nome do checkout, escritas como no plano. Vazio: bate. */
export function palavrasDoPlanoQueFaltam(nomeDoCheckout: string, nomeDoPlano: string): string[] {
  const doCheckout = new Set(palavras(nomeDoCheckout));
  return nomeDoPlano
    .split(/\s+/)
    .filter((p) => palavras(p).some((x) => !doCheckout.has(x)))
    .map(semSimbolo);
}

/** "Exame", "Exame e Start", "Fast, Exame e Start". */
export function emLista(itens: string[]): string {
  const q = itens.map((i) => `"${i}"`);
  return q.length < 2 ? (q[0] ?? "") : `${q.slice(0, -1).join(", ")} e ${q[q.length - 1]}`;
}
